export default {
  action: (store) => (pageId) => (store.actions ? store.actions.find((action) => action.id === +pageId) : null),
};
